import React from 'react';

export const FlagSQ = ({ className = "w-5 h-3.5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
    <rect width="640" height="480" fill="#e41e20" />
    <g fill="#000000" transform="translate(320,240) scale(0.65)">
      {/* Center body & tails */}
      <path d="M-12,40 C-30,80 -60,110 -90,130 C-50,115 -25,95 -5,60 C-8,90 -20,130 -40,160 C-10,140 10,140 40,160 C20,130 8,90 5,60 C25,95 50,115 90,130 C60,110 30,80 12,40 C20,10 20,-30 0,-50 C-20,-30 -20,10 -12,40 Z" />
      {/* Left wing feathers */}
      <path d="M-15,-30 C-50,-40 -110,-40 -160,-20 C-180,-10 -200,10 -220,40 C-190,20 -150,10 -120,10 C-150,30 -180,60 -195,95 C-170,75 -135,60 -105,55 C-130,80 -150,110 -160,140 C-135,115 -105,95 -80,85 C-95,110 -105,135 -110,160 C-90,135 -65,115 -45,100 C-30,50 -20,10 -15,-30 Z" />
      {/* Right wing feathers */}
      <path d="M15,-30 C50,-40 110,-40 160,-20 C180,-10 200,10 220,40 C190,20 150,10 120,10 C150,30 180,60 195,95 C170,75 135,60 105,55 C130,80 150,110 160,140 C135,115 105,95 80,85 C95,110 105,135 110,160 C90,135 65,115 45,100 C30,50 20,10 15,-30 Z" />
      {/* Left head and neck */}
      <path d="M-10,-45 C-25,-60 -45,-75 -70,-80 C-85,-83 -100,-75 -110,-60 C-95,-60 -85,-55 -80,-45 C-95,-45 -105,-40 -115,-30 C-95,-25 -80,-30 -65,-35 C-45,-40 -25,-40 -10,-45 Z" />
      <circle cx="-85" cy="-68" r="3" fill="#e41e20" />
      <path d="M-105,-68 L-125,-65 L-105,-60 Z" />
      <path d="M-112,-63 L-128,-60 L-110,-55 Z" />
      {/* Right head and neck */}
      <path d="M10,-45 C25,-60 45,-75 70,-80 C85,-83 100,-75 110,-60 C95,-60 85,-55 80,-45 C95,-45 105,-40 115,-30 C95,-25 80,-30 65,-35 C45,-40 25,-40 10,-45 Z" />
      <circle cx="85" cy="-68" r="3" fill="#e41e20" />
      <path d="M105,-68 L125,-65 L105,-60 Z" />
      <path d="M112,-63 L128,-60 L110,-55 Z" />
      {/* Crown / Top crest */}
      <path d="M-25,-85 L0,-115 L25,-85 L12,-80 L0,-95 L-12,-80 Z" />
    </g>
  </svg>
);

export const FlagEN = ({ className = "w-5 h-3.5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg">
    <clipPath id="flag-en-s">
      <path d="M0,0 v30 h60 v-30 z"/>
    </clipPath>
    <clipPath id="flag-en-t">
      <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/>
    </clipPath>
    <g clipPath="url(#flag-en-s)">
      <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#flag-en-t)" stroke="#C8102E" strokeWidth="4"/>
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
    </g>
  </svg>
);

export const FlagDE = ({ className = "w-5 h-3.5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
    <path fill="#000" d="M0 0h640v160H0z"/>
    <path fill="#d00" d="M0 160h640v160H0z"/>
    <path fill="#ffce00" d="M0 320h640v160H0z"/>
  </svg>
);
